<script setup lang="ts">
import type { CheckboxFieldConfig, Locale } from '@/forms/types'

const props = defineProps<{
  field: CheckboxFieldConfig
  locale: Locale
  modelValue: boolean
  error?: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const errorId = `${props.field.id}-error`
</script>

<template>
  <div class="field" :class="{ 'has-error': !!error }">
    <label class="row" :for="field.id">
      <input
        :id="field.id"
        type="checkbox"
        :checked="modelValue"
        :required="field.required"
        :aria-required="field.required ? 'true' : undefined"
        :aria-invalid="error ? 'true' : undefined"
        :aria-describedby="error ? errorId : undefined"
        @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
      />
      <span class="text">
        {{ field.label[locale] }}
        <span v-if="field.required" aria-hidden="true" class="req">*</span>
      </span>
    </label>
    <p v-if="error" :id="errorId" class="field-error" role="alert">{{ error }}</p>
  </div>
</template>

<style scoped>
.field {
  margin-bottom: var(--space-5);
}
.row {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  cursor: pointer;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-base);
}
.text {
  flex: 1;
}
.req {
  color: var(--color-brand-dark);
  margin-left: 2px;
}
input[type='checkbox'] {
  margin-top: 0.2rem;
  accent-color: var(--color-text);
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}
.field-error {
  margin-left: calc(1rem + var(--space-3));
}
</style>
